module.exports = __webpack_public_path__ + "img/sidebar-arrow-icon.20c7b527.svg";